{ "closeAria": "닫기", "historyAria": "문의 내역", "supportTitle": "지원" }
